<template>
    <div class="key-regular-route">
        <m-pane
            ref="tablePage"
            class="tablePage"
            pageID="processInfo"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="searchParams.pageNo"
            @refresh-btn="handleRefresh"
            @search-btn="showSearch"
            @add-btn="handleAdd"
            @edit-btn="handleEdit"
            @copy-btn="handleCopy"
            @approve-btn="handleApprove"
            @record-btn="showRecord"
            @delete1-btn="handleDelete"
            @selectChange="selectChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <!-- <div slot="search">
                <div style="margin-bottom: 10px;">
                    <el-row>
                        <el-col :span="4" class="flex">
                            <span class="search-label">始发地</span>
                            <AddrCascader
                                    v-model="searchObj.start"
                                    :minLayers="3"
                                    :placeholder="'始发地'"
                                    :collapseTags="true"
                                    :basicProps="{ checkStrictly: true }"></AddrCascader>
                        </el-col>
                        <el-col :span="4" class="flex">
                            <span class="search-label">目的地</span>
                            <AddrCascader
                                    v-model="searchObj.end"
                                    :minLayers="3"
                                    :placeholder="'目的地'"
                                    :collapseTags="true"
                                    :basicProps="{ checkStrictly: true }"></AddrCascader>
                        </el-col>
                    </el-row>
                </div>
            </div> -->
        </m-pane>
        <operate-dialog ref="operate" :isSupplier="isSupplier" :supplierTab="supplierTab" @add="handleAddEffect" />
        <searchDialog @confirm="handleConfirm" :searchObj="searchObj" ref="searchDialog"/>
        <approveRecordDialog ref="approveRecordDialog"/>
    </div>
</template>

<script>
import AddrCascader from '../../../../../resource/transportPortrait/components/AddrCascader/index.vue'
import config from './config.js';
import supplierConfig from './supplierConfig.js';
import OperateDialog from './OperateDialog.vue';
import mPane from '../../../../../../components/Table/Index.vue';
import { supplierCommonRoutePage, supplierCommonRouteDel, supplierCommonRouteSubmit } from '../../../../../../api/regularRoute.js';
import { dictWithUrl } from '@/components/lots/api';
import { cloneDeep } from 'lodash'
import searchDialog from './searchDialog.vue'
import approveRecordDialog from './approveRecordDialog.vue'

export default {
    name: 'Qualification',
    components: { mPane, OperateDialog, AddrCascader, searchDialog, approveRecordDialog },
    props: {
        supplierTab: {
            type: Object,
            default: () => {}
        },
        activeCode: {
            type: String,
            default() {
                return '';
            }
        },
        code: {
            type: String,
            default() {
                return '';
            }
        }
    },
    watch: {
        supplierTab() {
            this.handleSearch();
        },
        activeCode(nVal) {
            if (this.code === nVal) {
                this.handleSearch();
            }
        }
    },
    data() {
        return {
            loading: false,
            totalData: [],
            pageTotal: 0,
            selected: [],
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            searchObj: {
                start: [],
                end: [],
                isSelfManage: '',
                approvalStatusList: [],
                originStationName: '',
                destinationStationName: '',
            },
            dict: {}
        };
    },
    computed: {
        config() {
            return !this.$store.state.supplier ? config : supplierConfig;
        },
        isSupplier() {
            return !!this.$store.state.supplier;
        }
    },
    mounted() {
        dictWithUrl('DC_ROUTE_TYPE,SRM_INDUSTRY_TYPE,TMS_VEHICLE_BIG_TYPE,SRM_YES_NO,SRM_COMMON_ROUTE_AUDIT_STATUS,SRM_COMMON_ROUTE_AUDIT_TYPE').then(res => {
            this.dict = res.data;
            this.handleSearch();
        });
    },
    methods: {
        showRecord(row){
            this.$refs['approveRecordDialog'].open(row.id)
        },
        handleApprove(){
            if (this.selected.length === 0) {
                return this.$message.warning(`请选择线路`);
            }
            // if(this.supplierTab.businessType !== '3'){
            //     return this.$message.warning(`供应商业务类型必须是运输`)
            // }
            if(this.selected.every(v => v.isSelfManage === '1' && ['1', '4'].includes(v.approvalStatus))){
                //【零担自营线路=是】且【审批状态=待发起、审批不通过】的线路
                this.$confirm('是否发起审批?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    supplierCommonRouteSubmit(this.selected.map(v => v.id)).then(res => {
                    if (res && +res.code === 0) {
                        this.$router.push(`${this.isSupplier?'/lsrm':''}/mipIframe?processId=${res.data}&routeIds=${this.selected.map(v => v.id)}&path=${encodeURIComponent(this.$route.fullPath)}`)
                    }
                })
                }).catch(() => {
                });
            }else{
                this.$message.warning(`仅零担专线供应商的零担自营线路，且审批状态为待发起或审批不通过的线路需发起审批，请重新选择`)
            }
        },
        handleConfirm(v){
            this.searchParams.pageNo = 1
            this.searchObj = cloneDeep(v)
            this.handleSearch()
        },
        showSearch(){
            this.$refs['searchDialog'].open()
        },
        handleRefresh(){
            this.searchParams.pageNo = 1
            this.searchObj = {
                start: [],
                end: [],
                isSelfManage: '',
                approvalStatusList: [],
                originStationName: '',
                destinationStationName: '',
            }
            if (this.supplierTab.supplierCode) {
                const params = {
                    supplierCode: this.supplierTab.supplierCode,
                    ...this.searchParams
                };
                this.loading = true;
                supplierCommonRoutePage(params).then(res => {
                    this.loading = false;
                    if (res && +res.code === 0) {
                        this.totalData = this.formatData(res.data.list);
                        this.pageTotal = res.data.totalCount;
                    }
                }).catch(() => { this.loading = false; });
            }
        },
        handleSearch() {
            if (this.supplierTab.supplierCode) {
                const params = {
                    supplierCode: this.supplierTab.supplierCode,
                    ...this.searchObj,
                    originProv: this.searchObj.start.length === 1 ? this.searchObj.start[0] : '',
                    originCity: this.searchObj.start.length === 2 ? this.searchObj.start[1] : '',
                    originCounty: this.searchObj.start.length === 3 ? this.searchObj.start[2] : '',
                    destinationProv: this.searchObj.end.length === 1 ? this.searchObj.end[0] : '',
                    destinationCity: this.searchObj.end.length === 2 ? this.searchObj.end[1] : '',
                    destinationCounty: this.searchObj.end.length === 3 ? this.searchObj.end[2] : '',
                    ...this.searchParams
                };
                delete params.start
                delete params.end
                this.loading = true;
                supplierCommonRoutePage(params).then(res => {
                    this.loading = false;
                    if (res && +res.code === 0) {
                        this.totalData = this.formatData(res.data.list);
                        this.pageTotal = res.data.totalCount;
                    }
                }).catch(() => { this.loading = false; });
            }
        },
        handleAdd() {
            this.$refs.operate.init();
        },
        handleEdit(row) {
            this.$refs.operate.init(row);
        },
        handleCopy(row) {
            const newRow = cloneDeep(row);
            newRow.id = '';
            newRow.routeNo = '';
            newRow.routeName = '';
            this.$refs.operate.init(newRow, 'copy');
        },
        handleAddEffect() {
            this.$set(this.searchParams, 'pageNo', 1);
            this.handleSearch();
        },
        handleDelete() {
            if (this.selected.length === 0) {
                this.$message({ type: 'warning', message: '请先选择删除线路！' });
                return;
            }
            // if (this.selected.length > 1) {
            //     this.$message({ type: 'warning', message: '只能选择一项进行删除！' });
            //     return;
            // }
            this.$confirm('请确认是否删除当前常跑路线?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                supplierCommonRouteDel(this.selected.map(v => v.id)).then(res => {
                    if (res && +res.code === 0) {
                        this.$message({ type: 'success', message: '删除成功!' });
                        this.handleSearch();
                    }
                });
            }).catch(() => {
                // this.$message({ type: 'info', message: '已取消删除' });
            });
        },
        selectChange(data) {
            this.selected = [].concat(data);
        },
        pageChange(data) {
            this.$emit('sensitive')
            this.searchParams.pageNo = data;
            this.handleSearch();
        },
        sizeChange(data) {
            this.$emit('sensitive')
            this.$set(this.searchParams, 'pageSize', data);
            this.$set(this.searchParams, 'pageNo', 1);
            this.handleSearch();
        },
        formatData(list = []) {
            return list.map(item => {
                // item.routeType_ = this.dict.DC_ROUTE_TYPE[item.routeType];
                item.approvalType_ = this.dict['SRM_COMMON_ROUTE_AUDIT_TYPE'][item.approvalType];
                item.approvalStatus_ = this.dict['SRM_COMMON_ROUTE_AUDIT_STATUS'][item.approvalStatus];
                item.isSelfManage_ = this.dict['SRM_YES_NO'][item.isSelfManage];
                item.homeTransExp_ = this.dict['SRM_YES_NO'][item.homeTransExp];
                item.carType_ = item.carType ? (item.carType.split(',').map(v => this.dict['TMS_VEHICLE_BIG_TYPE'][v]) + '') : ''
                item.industryType_ = item.industryType ? (item.industryType.split(',').map(v => this.dict['SRM_INDUSTRY_TYPE'][v]) + '') : ''
                return item;
            });
        }
    }
};
</script>
<style lang="less">
.key-regular-route{
    .flex{
        display: flex;
        align-items: center;
        margin-right: 10px;
    }
    .search-label{
        font-size: 12px;
        white-space: nowrap;
        margin-right: 10px;
    }
}
</style>